module.exports = __webpack_public_path__ + "static/media/path0401.fdce575b.jpg";